import axios, {AxiosRequestConfig} from 'axios';

import {ApiSuccessResponse} from './types';

type Params = {
  params?: AxiosRequestConfig['params'];
  withCredentials?: AxiosRequestConfig['withCredentials'];
  signal?: AxiosRequestConfig['signal'];
};

export function httpPut<T>(
  url: string,
  data?: AxiosRequestConfig['data'],
  params?: Params
) {
  return axios.put<ApiSuccessResponse<T>>(url, data, params);
}
